import React, {memo} from "react";
import {Modal} from 'react-bootstrap';

const BaseModal = (props) => {
    const {title,children,show,handleClose,dialogClassName} = props;
    return (
        <>
            <Modal dir={'rtl'} show={show} onHide={handleClose} scrollable={true} centered={true} dialogClassName={typeof dialogClassName === undefined ? 'modal-dialog-scrollable-custom' : 'modal-dialog-scrollable-custom '+dialogClassName}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                {children}
            </Modal>
        </>
    )
};

export default memo(BaseModal);
